'use client'

import nextDynamic from 'next/dynamic'
import React from 'react'

export const dynamic = 'force-static'

const App = nextDynamic(() => import('./_src/App'), { ssr: false })

export function StaticShell() {
  return <App />
}
